module.exports = __webpack_public_path__ + "static/img/backModel.1ca7f1a5.jpg";